module.exports = __webpack_public_path__ + "static/media/05_tn.fd2f0c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/05_tn.jpg
// module id = 435
// module chunks = 0